import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { heroVideoUrl } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[100svh] flex items-center justify-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <iframe
          src={heroVideoUrl}
          title="Definition Films showreel"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.77vh] h-[56.25vw] min-w-full min-h-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65" />

      <div className="relative z-10 w-full px-4 md:px-10 text-center">
        <Reveal>
          <h1 className="mx-auto max-w-5xl font-heading font-extrabold uppercase leading-[1.05] tracking-tight text-background-50 text-3xl sm:text-4xl md:text-6xl">
            Cinematic storytelling for brands in Sonoma County and beyond.
          </h1>
        </Reveal>
        <Reveal delay={140}>
          <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg text-background-100/90">
            From Sonoma County wineries, non-profits to global brands, we help organizations
            tell the stories that define them.
          </p>
        </Reveal>
        <Reveal delay={280}>
          <Link
            to="/contact"
            className="mt-9 inline-block border-b border-accent-400 pb-1 font-label text-xs md:text-sm tracking-[0.22em] uppercase text-background-50 transition-colors duration-200 hover:text-accent-400"
          >
            Let's Talk About Your Story
          </Link>
        </Reveal>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-background-100/70 animate-bounce">
        <i className="ri-arrow-down-line text-2xl" />
      </div>
    </section>
  );
}